import gql from 'graphql-tag';
import apollo from '../apollo';
import { getEntityListWithAccount } from '../../utils/AppUtil';

const CREATE_SURVEY_TEMPLATE_QUERY = gql`
  mutation createSurveyTemplate($input: CreateSurveyTemplateInput!) {
    createSurveyTemplate(input: $input) {
      template {
        id
      }
    }
  }
`;

export const createNewTemplate = input => apollo
  .mutate({
    mutation: CREATE_SURVEY_TEMPLATE_QUERY,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const UPDATE_SURVEY_TEMPLATE_QUERY = gql`
  mutation($input: UpdateSurveyTemplateDetailsInput!) {
    updateSurveyTemplateDetails(input: $input) {
      template {
        id
        title
        inviteTemplateId
        thankYouTemplateId
        reminderTemplateId
        feedbackTemplateId
      }
    }
  }
`;

export const updateTemplate = input => apollo
  .mutate({
    mutation: UPDATE_SURVEY_TEMPLATE_QUERY,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const TEMPLATE_EXEC_REPORT_QUERY = gql`
  query surveyTemplates($accountId: ID!, $first: Int) {
    account(id: $accountId) {
      id
      surveyTemplates(first: $first) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

export const searchSurveyTemp = ({ aid, query }) => {
  const sort = {
    sortBy: 'title',
    sortDir: 'ASC',
  };

  const variables = {
    accountId: aid,
    first: 999,
    filter: {
      query,
    },
    sort,
  };

  return apollo
    .query({
      query: TEMPLATE_EXEC_REPORT_QUERY,
      variables,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => {
      const { account } = data;
      const processed = getEntityListWithAccount(account, 'surveyTemplates');
      return processed;
    });
};
